import axios from "axios";

export default axios.create({
  baseURL: "https://elmsbk.aeontechhub.com",
});
